import { Controller } from "@hotwired/stimulus"

// Reloads the page once a form nested in this frame has been submitted successfully:
// the created record belongs to a list this frame does not own.
export default class extends Controller {
  submitEnd(event) {
    if (event.detail?.success) window.location.reload()
  }
}
